import { gql } from '@apollo/client';

export const GetQuery = (query) => query;

export const APP_EMPLOYEE_NAMES_QUERY = gql`
query searchEmployeeNamesById($EmployeeId: String!)
{
  searchEmployeeNamesById(EmployeeId: $EmployeeId) {
    EmployeeId
    FirstName
    LastName
  }
}
`;

export const APP_EMPLOYEES_BY_JOB_ROLE = gql`
query searchEmployeesByJobRole($JobRole: String!)
{
  searchEmployeesByJobRole(JobRole: $JobRole) {
    EmployeeId
    person {
      FirstName
      LastName
    }
  }
}
`;

export const SECURITY_USER_GB_EMAIL_QUERY = gql`
query GetAuthenticatedUser($email:String!)
{
  user(email:$email){
    UserId
    EmployeeId
    EmailAddress
    LastName
    FirstName
    AppRole
    Claims{
      CodeMappingEnterpriseCreate 
      CodeMappingEnterpriseEdit 
      CodeMappingEnterpriseSearch 
      CodeMappingEnterpriseDelete 
      RulesConfigurationEnterpriseCreate 
      RulesConfigurationEnterpriseEdit 
      RulesConfigurationEnterpriseSearch 
      RulesConfigurationEnterpriseDelete 
      RulesConfigurationCustomCreate 
      RulesConfigurationCustomEdit 
      RulesConfigurationCustomSearch 
      RulesConfigurationCustomDelete
    }
  }
}
`;
export const SECURITY_USER_GB_USERNAME_PASSWORD_QUERY = gql`
query GetUserByCredentials($UserName:String!,$Password:String!)
{
  user(userName:$UserName, password:$Password){
    UserId
    EmployeeId
    UserName
    Password
    Token
    Role{
    RoleId
      Name
      IsTemplate
    }
    Claims{
      RoleId
      EntityId
      Access
      Read
      Write
      Execute
      Executebatch
    }
  }
}
`;
/**
@param {string} ALERTS_SCHEDULE_TODAY_MY_TEAM Alerts schedule type for my team today
*/
export const ALERTS_SCHEDULE_TODAY_MY_TEAM = gql`
  query todayScheduleForMyTeam($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    todayScheduleForMyTeam(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count 
    }
  }
`;
/**
@param {string} ALERTS_SCHEDULE_WEEKLY_MY_TEAM Alerts schedule type for my team this week
 */
export const ALERTS_SCHEDULE_WEEKLY_MY_TEAM = gql`
  query thisWeekScheduleForMyTeam($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    thisWeekScheduleForMyTeam(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_SCHEDULE_CUSTOM_MY_TEAM Alerts schedule type for my team custom date
 */
export const ALERTS_SCHEDULE_CUSTOM_MY_TEAM = gql`
  query customScheduleForMyTeam($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean, $CustomInit: String!, $CustomEnd: String!) {
    customScheduleForMyTeam(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage, CustomInit: $CustomInit, CustomEnd: $CustomEnd) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_SCHEDULE_TODAY_OTHER_TEAMS Alerts schedule type for other teams today
 */
export const ALERTS_SCHEDULE_TODAY_OTHER_TEAMS = gql`
  query todayScheduleForOtherTeams($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    todayScheduleForOtherTeams(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        SupervisorEmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_SCHEDULE_WEEKLY_OTHER_TEAMS Alerts schedule type for other teams this week
 */
export const ALERTS_SCHEDULE_WEEKLY_OTHER_TEAMS = gql`
  query thisWeekScheduleForOtherTeams($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    thisWeekScheduleForOtherTeams(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        SupervisorEmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_SCHEDULE_CUSTOM_OTHER_TEAMS Alerts schedule type for other teams custom date
 */
export const ALERTS_SCHEDULE_CUSTOM_OTHER_TEAMS = gql`
  query customScheduleForOtherTeams($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean, $CustomInit: String!, $CustomEnd: String!) {
    customScheduleForOtherTeams(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage, CustomInit: $CustomInit, CustomEnd: $CustomEnd) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        SupervisorEmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_ACTIVITY_TODAY_MY_TEAM Alerts activity type for my team today
 */
export const ALERTS_ACTIVITY_TODAY_MY_TEAM = gql`
  query todayActivityForMyTeam($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    todayActivityForMyTeam(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
/**
@param {string} ALERTS_ACTIVITY_TODAY_OTHER_TEAMS Alerts activity type for other teams today
 */
export const ALERTS_ACTIVITY_TODAY_OTHER_TEAMS = gql`
  query todayActivityForOtherTeams($EmployeeId: Float!, $LastKey: Int, $NextPage: Boolean) {
    todayActivityForOtherTeams(EmployeeId: $EmployeeId, LastKey: $LastKey, NextPage: $NextPage) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        SupervisorEmployeeData
        UTCStartMomentTS
        UTCStopMomentTS
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
    }
  }
`;
export const APP_ALERT_CLIENTS_GL_QUERY = gql`
query getClients($ParentOrganization: String)
{
  getClients(ParentOrganization: $ParentOrganization) {
    ClientId
    DescriptionShort
    ParentOrganizationId
  }
}
`;
export const APP_ALERT_CLIENTS_ALIAS_GL_QUERY = gql`
query getClients($ParentOrganization: String)
{
  getClients(ParentOrganization: $ParentOrganization) {
    ChildrenId: ClientId
    ChildrenLabel: DescriptionShort
    ParentId: ParentOrganizationId
  }
}
`;
export const APP_ALERT_PARENT_ORGANIZATIONS_GL_QUERY = gql`
query getParentOrganizations
{
  getParentOrganizations {
    ParentOrganizationId
    DescriptionShort
    DescriptionLong
    Active
    StartDate
    EndDate
    clients {
      ClientId
      DescriptionShort
    }
  }
}
`;
export const APP_ALERT_PARENT_ORGANIZATIONS_FORMATTED_GL_QUERY = gql`
query getParentOrganizations
{
  getParentOrganizations {
    ParentId: ParentOrganizationId
    ParentLabel: DescriptionShort
    children: clients {
      ChildrenId: ClientId
      ChildrenLabel: DescriptionShort
    }
  }
}
`;
export const APP_ALERT_PROGRAMS_GL_QUERY = gql`
query getPrograms($ClientId: String!)
{  
  getPrograms(ClientId: $ClientId){
    ProgramId
    DescriptionShort
    ClientId
  }
}
`;
export const APP_ALERT_PROJECTS_GL_QUERY = gql`
query getProjects($ProgramId: String!)
{
  getProjects(ProgramId: $ProgramId){
    ProjectId
    DescriptionShort
    ClientId
    ProgramId
  }
}
`;
export const APP_ALERT_SITES_GL_QUERY = gql`
query getSites
{
  getSites{
    SiteId
    DescriptionShort
  }
}
`;
export const APP_ALERT_SUBSCRIPTIONS_GB_QUERY = gql`
query getActiveSubscriptions($EmployeeId: String!){
  getActiveSubscriptions(EmployeeId: $EmployeeId)
  {
    SubscriptionId
    ClientCode
    ClientName
    ProgramCode
    ProgramName
    ProjectCode
    ProjectName
    SiteCode
    SiteName
    SupervisorName
    SupervisorEmployeeId
  }
}
`;
export const SUBSCRIBED_SCHEDULE_ALERT = gql`
query searchScheduleAlertsForSubscriptions(
  $ClientId: String, 
  $ProgramId: String, 
  $ProjectId: String, 
  $SiteId: String, 
  $AgentEmployeeId: String, 
  $AgentEmployeeName: String, 
  $SupervisorEmployeeId: String,
  $LastKey: Int,
  $NextPage: Boolean
  ) {
  searchScheduleAlertsForSubscriptions(
    ClientId: $ClientId, 
    ProgramId: $ProgramId, 
    ProjectId: $ProjectId, 
    SiteId: $SiteId, 
    AgentEmployeeId: $AgentEmployeeId, 
    AgentEmployeeName: $AgentEmployeeName, 
    SupervisorEmployeeId: $SupervisorEmployeeId
    LastKey: $LastKey
    NextPage: $NextPage
    ) {
      data {
        rowNumber
        AlertTypeDesc
        EmployeeId
        EmployeeData
        SupervisorEmployeeData
        UTCStartMomentTS
        UTCStopMomentTS 
        Duration
        Status
        Client 
        Program
        Project
        Site
      }
      count
  }
}
`;
export const SUBSCRIBED_PERFORMANCE_ALERT = gql`
query searchPerformanceAlertsForSubscriptions(
  $ClientId: String, 
  $ProgramId: String, 
  $ProjectId: String, 
  $SiteId: String, 
  $AgentEmployeeId: String, 
  $AgentEmployeeName: String, 
  $SupervisorEmployeeId: String,
  $LastKey: Int,
  $NextPage: Boolean
) {
  searchPerformanceAlertsForSubscriptions(
    ClientId: $ClientId, 
    ProgramId: $ProgramId, 
    ProjectId: $ProjectId, 
    SiteId: $SiteId, 
    AgentEmployeeId: $AgentEmployeeId, 
    AgentEmployeeName: $AgentEmployeeName, 
    SupervisorEmployeeId: $SupervisorEmployeeId
    LastKey: $LastKey
    NextPage: $NextPage
  ) {
    data {
      rowNumber
      AlertTypeDesc
      EmployeeId
      EmployeeData
      SupervisorEmployeeData
      UTCStartMomentTS
      UTCStopMomentTS 
      Duration
      Status
      Client 
      Program
      Project
      Site
    }
    count
  }
}
`;
export const APP_ALERT_UNSUSCRIBE_MUTATION = gql`
mutation unSubscribeToOtherTeam($SubscriptionId: Int!, $EmployeeId: String! ){
  unSubscribeToOtherTeam(SubscriptionId: $SubscriptionId, EmployeeId: $EmployeeId)
  {
    InsertedId
    Status
  }
}`;
export const APP_ALERT_SUBSCRIBE_BY_CPPS_MUTATION = gql`
mutation subscribeToOtherTeamByCPPS($ClientCode: String, $ProgramCode: String, $ProjectCode: String, $SiteCode: String, $EmployeeId: String){
  subscribeToOtherTeamByCPPS(ClientCode: $ClientCode, ProgramCode: $ProgramCode, ProjectCode: $ProjectCode, SiteCode: $SiteCode, EmployeeId: $EmployeeId)
  {
    Status
  }
}`;
export const APP_ALERT_SUBSCRIBE_BY_SUPERVISOR_MUTATION = gql`
mutation subscribeToOtherTeamBySupervisor($EmployeeId: String, $SupervisorEmployeeId: String){
  subscribeToOtherTeamBySupervisor(EmployeeId: $EmployeeId, SupervisorEmployeeId: $SupervisorEmployeeId)
  {
    Status
  }
}`;
export const COUNT_SCHEDULE_ALERT = gql`
query countScheduleAlerts($EmployeeId: Float!, $CustomInit: String, $CustomEnd: String){
  countScheduleAlerts(EmployeeId: $EmployeeId, CustomInit: $CustomInit, CustomEnd: $CustomEnd) {
    myTeamTodayCounts {
      scheduleAlarmDescription
      count
    }
    myTeamWeeklyCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsTodayCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsWeeklyCounts {
      scheduleAlarmDescription
      count
    }
    myTeamCustomCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsCustomCounts {
      scheduleAlarmDescription
      count
    }
  }
}`;
export const COUNT_PERFORMANCE_ALERT = gql`
query countPerformanceAlerts($EmployeeId: Float!){
  countPerformanceAlerts(EmployeeId: $EmployeeId) {
    myTeamTodayCounts {
      scheduleAlarmDescription
      count
    }
    myTeamWeeklyCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsTodayCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsWeeklyCounts {
      scheduleAlarmDescription
      count
    }
    myTeamCustomCounts {
      scheduleAlarmDescription
      count
    }
    otherTeamsCustomCounts {
      scheduleAlarmDescription
      count
    }
  }
}`;
export const SUPERVISORS_GA_QUERY = gql`
query supervisors{
  supervisors{
    SupervisorEmployeeId
    SupervisorEmployeeData
  }
}
`;
export const ASPECT_STATUS_QUERY = gql`
query aspectHealthWebService{
  aspectHealthWebService
}
`;
export const ASPECT_ALARMS_STATUS_QUERY = gql`
query aspectHealthAlarmsWebService{
  aspectHealthAlarmsWebService
}
`;
export const CODE_MAPPINGS_QUERY = gql`
query codeMappingsScheduleACD($input: ScheduleACDInput){
  codeMappingsScheduleACD(input: $input) {
    CodeMappingType
    CodeMappingId
    Label
    Description
    ScheduleType
    avaliblesCodes {
      mappingKey
      MappedCode
      Detail
    }
  }
}`;
export const CODE_MAPPING_QUERY = gql`
query codeMapping($id: Int!){
  codeMapping(id: $id) {
    CodeMappingId
    Label
    Description
    ScheduleTypeId
    ScheduleSegments {
      ScheduleSegmentExternalKey
      SourceSystemId
      ScheduleSegment {
        ScheduleSegmentDescription
      }
    }
  }
}`;
export const CODE_MAPPING_DELETE = gql`
mutation deleteCodeMapping($CodeMappingId: Int!) {
  deleteCodeMapping(CodeMappingId: $CodeMappingId)
  {
    status
  }
}
`;
export const ACD_CODE_MAPPING_DELETE = gql`
mutation deleteACDCodeMapping($ACDCodeMappingId: Int!) {
  deleteACDCodeMapping(ACDCodeMappingId: $ACDCodeMappingId)
  {
    status
  }
}
`;
export const CODE_MAPPING_ACD_AVALIBLE_CODES = gql`
query ACDStateReasons {
  ACDStateReasons {
    ACDStateReasonExternalKey
    ACDStateDescription
  }
}`;
export const CODE_LABELS_ACD_NAMES_QUERY = gql`
query labelsACDNames {
  ACDNames {
    ACDStateDescription
  }
}`;
export const CODE_MAPPING_SCHEDULE_AVALIBLE_CODES = gql`
query scheduleSegments($SourceSystemId: Int!) {
  scheduleSegments(SourceSystemId: $SourceSystemId) {
    ScheduleSegmentExternalKey
    ScheduleSegmentDescription
  }
}`;
export const CODE_MAPPING_CODE_LABELS_QUERY = gql`
query codeMappingCodeLabels {
  codeMappingCodeLabels {
    CodeMappingType
    CodeLabel
  }
}`;

export const CODE_MAPPING_SCHEDULE_TYPE_QUERY = gql`
query labelsScheduleType {
  scheduleTypes {
    Description
  }
}`;

// Deprecado
export const RULES_CONFIGURATION_DATA = gql`
query rulesConfigurationData {
rulesConfiguration {
    RuleId
    RuleName
    ScheduleAlarmCode
    UpdateBy
    UpdateDate
    RuleType {
      Description
    }
    AlertType {
      Description
    }
    Client {
      DescriptionShort
    }
    Program {
      DescriptionShort
    }
    Project {
      DescriptionShort
    }
    Site {
      DescriptionShort
    }
  }
}
`;

export const ALARM_TYPE = gql`
query scheduleAlarm {
  scheduleAlarm {
    ScheduleAlarmExternalKey
    ScheduleAlarmCode
  }
}
`;

export const ALL_ACD_STATES = gql`
query ($stateLabel: String) {
  getAllACDState(stateLabel: $stateLabel) {
    mappingKey
    MappedCode
    Detail
  }
}`
;

export const ACD_CODE_MAPPING_CREATE_UPDATE = gql`
mutation updateOrCreateACDCodeMapping($input: ACDCodeMappingInput){
  updateOrCreateACDCodeMapping(input: $input)
  {
    status
  }
}`
;

export const PERFORMANCE_ACD_STATUS = gql`
query PerformanceACDStatus {
  GetPerformanceACDStateLabel {
    ACDStateLabel
  }
}
`;
export const ACD_STATE = gql`
query {
  getAllACDCodeMapping {
    ACDCodeMappingId
    Label
  }
}
`;

export const CODE__MAPPING__SCHEDULE = gql`
query codeMappings {
  codeMappings {
    CodeMappingId
    ScheduleTypeId
    Label
  }
}
`;

export const RULE__TAG = gql`
query tagForRC {
  scheduleSegment {
    ScheduleSegmentExternalKey
    ScheduleSegmentCode
  }
}
`;

export const RULE__TAG__DURATION = gql`
query taDuration {
  tagDuration {
    TagDurationId
    Description
  }
}
`;

export const REPORTING__FILTERED__CPPS__FIRST__DIMENSION = gql`
query getReportingDataFilteredCPPSFirstDimension($client: String, $startDate: String, $endDate: String) {
  getReportingDataFilteredCPPSFirstDimension(client: $client, startDate: $startDate, endDate: $endDate) {
    ClientName
    ProgramName
    ProjectName
    SiteName
    Taggings
    TaggingAttempts
    Flaggings
    FlaggingAttempts
  }
}
`;

export const REPORTING__TAGGING__FLAGGING__THIRD__DIMENSION = gql`
query getReportingDataTaggingFlaggingThirdDimension($rule: String!, $client: String!, $program: String!, $project: String!, $site: String!, $lastKey: String, $nextPage: Boolean, $uniqueIDsToExclude: [Int], $startDate: String, $endDate: String) {
  getReportingDataTaggingFlaggingThirdDimension(rule: $rule, client: $client, program: $program, project: $project, site: $site, lastKey: $lastKey, nextPage: $nextPage, uniqueIDsToExclude: $uniqueIDsToExclude, startDate: $startDate, endDate: $endDate) {
    data {
      RowNumber
      AlertId
      AgentName
      AlertType
      RuleName
      Action
      Outcome
      TeamLeadName
      Date
      WeekNumber
      YearNumber
    }
    count
  }
}
`;

export const REPORTING__RULES__SECOND__DIMENSION = gql`
query getReportingDataRulesSecondDimension($client: String!, $program: String!, $project: String!, $site: String!, $startDate: String, $endDate: String) {
  getReportingDataRulesSecondDimension(client: $client, program: $program, project: $project, site: $site, startDate: $startDate, endDate: $endDate) {
    RuleName
    RuleOwner
    Taggings
    TaggingAttempts
    Flaggings
    FlaggingAttempts
  }
}
`;

export const CREATE__UPDATE__RULE = gql`
mutation UpdateOrCreateRule(
    $RuleId: Int,
    $RuleName: String,
    $RuleTypeId: Int,
    $AlertTypeId: Int,
    $ScheduleAlarmExternalKey: String,
    $ScheduleAlarmCode: String,
    $ClientCode: String,
    $ProgramCode: String,
    $ProjectCode: String,
    $SiteCode: String,
    $MinThreshold: Date,
    $MaxThreshold: Date,
    $TagDuration: String,
    $TagScheduleSegmentCode: String,
    $TagScheduleSegmentExternalKey: String,
    $TaggingWindow: Int,
    $HistoricalNotes: String,
    $FlagFrequency: Int,
    $NotifyAgent: Int,
    $NotifyAgentText: String,
    $ChannelId: String,
    $NotifyGA: Int,
    $NotifyGAText: String,
    $IncludeACDStatus: Int,
    $ACDStatus: String,
    $ACDCodeMappingId: Int,
    $ScheduleContainerCode: String,
    $IncludeContainer: Int,
    $ContainerCodeMappingId: Int,
    $ScheduleSegmentCode: String,
    $IncludeSegment: Int,
    $SegmentCodeMappingId: Int,
    $AdherenceReminder: Int,
    $PerformanceRepeat: Int,
    $SourceSystemId: Int,
    $CreateBy: String,
    $UpdateBy: String,
    $CreateDate: String,
    $IsActive: Boolean
  ){
  updateOrCreateRule(
    RuleId: $RuleId,
    RuleName: $RuleName,
    RuleTypeId: $RuleTypeId,
    AlertTypeId: $AlertTypeId,
    ScheduleAlarmExternalKey: $ScheduleAlarmExternalKey,
    ScheduleAlarmCode: $ScheduleAlarmCode,
    ClientCode: $ClientCode,
    ProgramCode: $ProgramCode,
    ProjectCode: $ProjectCode,
    SiteCode: $SiteCode,
    MinThreshold: $MinThreshold,
    MaxThreshold: $MaxThreshold,
    TagDuration: $TagDuration,
    TagScheduleSegmentCode: $TagScheduleSegmentCode,
    TagScheduleSegmentExternalKey: $TagScheduleSegmentExternalKey,
    TaggingWindow: $TaggingWindow,
    HistoricalNotes: $HistoricalNotes,
    FlagFrequency: $FlagFrequency,
    NotifyAgent: $NotifyAgent,
    NotifyAgentText: $NotifyAgentText,
    NotifyGA: $NotifyGA,
    NotifyGAText: $NotifyGAText,
    ChannelId: $ChannelId,
    IncludeACDStatus: $IncludeACDStatus,
    ACDStatus: $ACDStatus,
    ACDCodeMappingId: $ACDCodeMappingId,
    ScheduleContainerCode: $ScheduleContainerCode,
    IncludeContainer: $IncludeContainer,
    ContainerCodeMappingId: $ContainerCodeMappingId,
    ScheduleSegmentCode: $ScheduleSegmentCode,
    IncludeSegment: $IncludeSegment,
    SegmentCodeMappingId: $SegmentCodeMappingId,
    AdherenceReminder: $AdherenceReminder,
    PerformanceRepeat: $PerformanceRepeat,
    SourceSystemId: $SourceSystemId,
    CreateBy: $CreateBy,
    UpdateBy: $UpdateBy,
    CreateDate: $CreateDate,
    IsActive: $IsActive
    )
  {
    status
    reason
    details
  }
}`;

export const RULE__DUPLICATED_VALIDATION = gql`
query duplicatedRuleValidation(
  $RuleName: String,
  $RuleId: Int,
  $ACDStatus: String,
  $ScheduleAlarmCode: String,
  $IncludeACDStatus: Int,
  $AlertTypeId: Int,
  $ScheduleSegmentCode: String,
  $IncludeSegment: Int,
  $ContainerCodeMappingId: Int,
  $IncludeContainer: Int,
  $TagDuration: String,
  $RuleTypeId: Int,
  $ClientCode: String,
  $ProgramCode: String,
  $ProjectCode: String,
  $SiteCode: String
  ){
    duplicatedRuleValidation(
    RuleName: $RuleName,
    RuleId: $RuleId,
    AlertTypeId: $AlertTypeId,
    TagDuration: $TagDuration,
    ScheduleAlarmCode: $ScheduleAlarmCode,
    IncludeACDStatus: $IncludeACDStatus,
    ACDStatus: $ACDStatus,
    IncludeContainer: $IncludeContainer,
    ContainerCodeMappingId: $ContainerCodeMappingId,
    ScheduleSegmentCode: $ScheduleSegmentCode,
    IncludeSegment: $IncludeSegment,
    RuleTypeId: $RuleTypeId,
    ClientCode: $ClientCode,
    ProgramCode: $ProgramCode,
    ProjectCode: $ProjectCode,
    SiteCode: $SiteCode
    )
  {
    status
    reason
    details
  }
}`;

export const VALIDATE_ADHERENCE_RULE_DUPLICATED = gql`
query duplicatedAdherenceRuleValidation($ScheduleSegmentCode: String!, $RuleId: Int, $RuleName: String) {
  duplicatedAdherenceRuleValidation(ScheduleSegmentCode: $ScheduleSegmentCode, RuleId: $RuleId, RuleName: $RuleName) {
    result
    details
  }
}
`;

export const VALIDATE_PERFORMANCE_RULE_DUPLICATED = gql`
query duplicatedPerformanceRuleValidation($ACDStatus: String!, $RuleId: Int, $RuleName: String) {
  duplicatedPerformanceRuleValidation(ACDStatus: $ACDStatus, RuleId: $RuleId, RuleName: $RuleName) {
    result
    details
  }
}
`;

export const VALIDATE_RULE_NAME = gql`
query isRuleDuplicatedByName($RuleName: String!) {
  isRuleDuplicatedByName(RuleName: $RuleName)
}
`;

export const FIND__GRID__DATA = gql`
query FindGridData(
  $RuleTypeId: Int,
  $AlertTypeId: Int,
  $ClientCode: String,
  $ProgramCode: String,
  $ProjectCode: String,
  $SiteCode: String,
  ) {
    findGridData(
      RuleTypeId: $RuleTypeId, 
      AlertTypeId: $AlertTypeId
      ClientCode: $ClientCode,
      ProgramCode: $ProgramCode,
      ProjectCode: $ProjectCode,
      SiteCode: $SiteCode,
      ) {
        RuleId
        RuleName
        Client {
          ClientId
          DescriptionShort
        }
        Program {
          ProgramId
          DescriptionShort
        }
        Project {
          ProjectId
          DescriptionShort
        }
        Site {
          DescriptionShort
        }
        RuleType {
          Description
        }
        IncludeACDStatus
        ACDStatus
        ScheduleContainerCode
        IncludeContainer
        ScheduleSegmentCode
        IncludeSegment
        AlertType {
          Description
        }
        TagScheduleSegmentCode
        MinThreshold
        MaxThreshold
        TagDuration
        FlagFrequency
        HistoricalNotes
        NotifyAgent
        NotifyAgentText
        NotifyGA
        NotifyGAText
        UpdateBy
        UpdateDate
        ScheduleAlarmCode
        CreateBy
        IsActive
        DeactivationReason
        ZoomChannel {
          AccountId
          Name
        }
      }
  }
`;

export const DELETE__RULE = gql`
mutation DeleteRule($Id: Int!) {
  deleteRule(Id:$Id) 
  {
    status
  }
}
`;

export const EDIT__RULE = gql`
query RuleToEdit($RuleId: Int!) {
  ruleToEdit(RuleId: $RuleId) 
  {
    RuleName
    RuleTypeId
    ScheduleAlarmExternalKey
    ScheduleAlarmCode
    MinThreshold
    MaxThreshold
    TagDuration
    TagScheduleSegmentExternalKey
    TaggingWindow
    HistoricalNotes
    FlagFrequency
    NotifyAgent
    NotifyAgentText
    NotifyGA
    NotifyGAText
    IncludeACDStatus
    ACDStatus
    ACDCodeMappingId
    IncludeContainer
    ContainerCodeMappingId
    IncludeSegment
    SegmentCodeMappingId
    AdherenceReminder
    PerformanceRepeat
    SourceSystemId
    AlertType {
      Description
    }
    Client {
      ClientId
      DescriptionShort
    }
    Program {
      ProgramId
      DescriptionShort
    }
    Project {
      ProjectId
      DescriptionShort
    }
    Site {
      SiteId
      DescriptionShort
    }
    ContainerType {
      Label
    }
    SegmentType {
      Label
    }
    ScheduleSegmentTag {
      ScheduleSegmentCode
    }
    CreateBy
    CreateDate
    IsActive
    ZoomChannel {
      AccountId
      Name
    }
  }
}
`;
export const CODE_MAPPING_SOURCE_SYSTEMS = gql`
query sourceSystems {
  sourceSystems {
    SourceSystemId
    Description
  }
}`;

export const CODE_MAPPING_CREATE_UPDATE_MUTATION = gql`
mutation updateOrCreateCodeMapping($input: CodeMappingInput){
  updateOrCreateCodeMapping(input: $input)
  {
    status
  }
}`;

// deprecated
export const ADMIN_MANAGMENT_ROLES = gql`
query {
  roles {
    RoleId
    Name
    IsTemplate
  }
}`;

export const ADMIN_MANAGMENT_USERS_ROLES = gql`
query getRoles{
  jobRoles{
    JobRole
  }
}`;

export const ADMIN_MANAGMENT_EMPLOYEE_DATA = gql`
query getEmployeeData (
  $EmployeeFirstName: String,
  $EmployeeLastName: String,
  $EmployeeId: String,
  $JobRole: String,
  $JobSite: String
) {
  getEmployeeData (
    EmployeeFirstName: $EmployeeFirstName,
    EmployeeLastName: $EmployeeLastName,
    EmployeeId: $EmployeeId,
    JobRole: $JobRole,
    JobSite: $JobSite
  ) {
    EmployeeId
    SupervisorEmployeeId
    SupervisorFirstName
		SupervisorLastName
    JobRole
    person {
      Title
      FirstName
      LastName
    }
    admin {
      EmployeeId
    }
    SiteDescription
    AgentsCount {
      Amount
    }
  }
}`;

export const GRANTED_ADMIN_ACCESS = gql`
mutation($EmployeeId: String!) { 
  grantAdminAccess(EmployeeId: $EmployeeId) {
    response
  }
}`;
export const REVOKED_ADMIN_ACCESS = gql`
mutation($EmployeeId: String!) {
  revokeAdminAccess(EmployeeId: $EmployeeId) {
    response
  }
}`;

export const ADMIN_MANAGMENT_SEARCH_AGENTS = gql`
query searchEmployeesBySupervisorId ($SupervisorId: String!) {
  searchEmployeesBySupervisorId(SupervisorId: $SupervisorId) {
    SupervisorEmployeeId
    EmployeeId
    person {
      FirstName
      LastName
    }
    JobRole
    SiteDescription
  }
}`;

export const ADMIN_MANAGEMENT_ROLE_PERMISSIONS = gql`
query getRoleActionPermission($selectedRole: String!) {
  roleActionPermissionByUserRole(UserRole: $selectedRole) {
    CodeMappingEnterpriseCreate
    CodeMappingEnterpriseEdit
    CodeMappingEnterpriseSearch
    CodeMappingEnterpriseDelete
    RulesConfigurationEnterpriseCreate
    RulesConfigurationEnterpriseEdit
    RulesConfigurationEnterpriseSearch
    RulesConfigurationEnterpriseDelete
    RulesConfigurationEnterpriseActive
    RulesConfigurationCustomCreate
    RulesConfigurationCustomEdit
    RulesConfigurationCustomSearch
    RulesConfigurationCustomDelete
    RulesConfigurationCustomActive
  }
}`;

export const ADMIN_MANAGEMENT_ROLE_PERMISSIONS_MUTATION = gql`
mutation updateRoleActionPermission(
  $selectedRole: String!
  $codeMappingEnterpriseCreate: Boolean
  $codeMappingEnterpriseEdit: Boolean
  $codeMappingEnterpriseSearch: Boolean
  $codeMappingEnterpriseDelete: Boolean
  $rulesConfigurationEnterpriseCreate: Boolean
  $rulesConfigurationEnterpriseEdit: Boolean
  $rulesConfigurationEnterpriseSearch: Boolean
  $rulesConfigurationEnterpriseDelete: Boolean
  $RulesConfigurationEnterpriseActive: Boolean
  $rulesConfigurationCustomCreate: Boolean
  $rulesConfigurationCustomEdit: Boolean
  $rulesConfigurationCustomSearch: Boolean
  $rulesConfigurationCustomDelete: Boolean
  $RulesConfigurationCustomActive: Boolean
){
  updateRoleActionPermission(
    UserRole: $selectedRole
    CodeMappingEnterpriseCreate: $codeMappingEnterpriseCreate 
    CodeMappingEnterpriseEdit: $codeMappingEnterpriseEdit
    CodeMappingEnterpriseSearch: $codeMappingEnterpriseSearch
    CodeMappingEnterpriseDelete: $codeMappingEnterpriseDelete
    RulesConfigurationEnterpriseCreate: $rulesConfigurationEnterpriseCreate
    RulesConfigurationEnterpriseEdit: $rulesConfigurationEnterpriseEdit
    RulesConfigurationEnterpriseSearch: $rulesConfigurationEnterpriseSearch
    RulesConfigurationEnterpriseDelete: $rulesConfigurationEnterpriseDelete
    RulesConfigurationEnterpriseActive: $RulesConfigurationEnterpriseActive
    RulesConfigurationCustomCreate: $rulesConfigurationCustomCreate
    RulesConfigurationCustomEdit: $rulesConfigurationCustomEdit
    RulesConfigurationCustomSearch: $rulesConfigurationCustomSearch
    RulesConfigurationCustomDelete: $rulesConfigurationCustomDelete
    RulesConfigurationCustomActive: $RulesConfigurationCustomActive
  )
  {
    status
  }
}`;

export const ADMIN_MANAGMENT_CREATE_CLIENT_PARENT_ACCESS = gql`
mutation createWFMClientParentAccess (
  $input: WFMClientParentAccessInput
) {
  createWFMClientParentAccess (
    input: $input
  ) {
    duplicated
    status
    }
}`;

export const ADMIN_MANAGMENT_SEARCH_CLIENT_PARENT_ACCESS = gql`
query getWFMClientParentAccess($EmployeeId: String!) {
  getWFMClientParentAccess(EmployeeId: $EmployeeId) {
    WFMClientParentAccessId
    ClientCode
    ParentOrganizationId
  }
}`;

export const ADMIN_MANAGMENT_DELETE_CLEINT_PARENT_ACCESS = gql`
mutation($input: WFMClientParentAccessInput) {
  deleteWFMClientParentAccess(input: $input) {
    status
  }
}`;

export const ACTIVATE__PAUSE__RULE = gql`
mutation($Id: Int!, $Play: Boolean!, $UpdateBy: String) {
  activateOrPauseRule(Id: $Id, Play: $Play, UpdateBy: $UpdateBy) {
    status
  }
}`;

export const CODE__MAPPING__FIND__ASSOCIATION = gql`
query FindAssociation($CodeMappingId: Int!, $Position: Int!) {
  findAssociation(CodeMappingId: $CodeMappingId, Position: $Position) {
    RuleId
    RuleName
  }
}`;

export const ADMINISTRATION_CREATE_CLIENT_PARENT_ACCESS = gql`
mutation($input: ClientParentAccessInput) {
  createClientParentAccess (input: $input) {
    duplicated
    status
    }
}`;

export const ADMINISTRATION_SEARCH_CLIENT_PARENT_ACCESS = gql`
query getClientParentAccess {
  getClientParentAccess {
    EmployeeId
    ClientId
  }
}`;

export const ADMINISTRATION_DELETE_CLEINT_PARENT_ACCESS = gql`
mutation($input: ClientParentAccessInput) {
  deleteClientParentAccess(input: $input) {
    duplicated
    status
  }
}`;

export const GET_ZOOM_CHANNELS = gql`
query {
  getZoomChannels {
    AccountId
    Name
  }
}`;